import React from 'react';
import styled from 'styled-components';


const Wrapper = styled.div`
	display: flex;
	width: ${props => props.width || '100%'};
	height: ${props => props.height || '100%'};
	flex-direction: ${props => props.vertical ? 'column' : 'row'};
	align-items: ${props => props.alignItems};
	justify-content: ${props => props.justifyContent};
	max-width: ${props => props.maxWidth};
	margin: ${props => props.margin};
	padding: ${props => props.padding};
	flex-wrap: ${props => props.wrap ? 'wrap' : 'nowrap'}
`;


export default class FlexBox extends React.Component {
	render() {
		return (
			<Wrapper className="ps-flexBox" {...this.props}>
				{this.props.children}
			</Wrapper>
		);
	}
}